import { ButtonControl, ScreenContainerControl } from "doshx_controls_web";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { sign_out_thunk } from "../../../reducers/slices/user";
import { setDrawerOpen } from "../../../reducers/slices/main";
import { faChartBar, faSignOut } from "@fortawesome/pro-solid-svg-icons";
import { ProfileDetailsWidget } from "./details";
import { AccountMenu } from "../../../components/account-menu/account-menu";
export const ProfilePage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.userState);
    // const { menuItems } = useOrdersState();
    useEffect(() => {
        //
    }, []);
    return (React.createElement(ScreenContainerControl, { className: "xl:max-w-[90vw] py-3" },
        React.createElement("div", { className: "w-full grid grid-cols-12 gap-8" },
            React.createElement("div", { className: "col-span-12 lg:col-span-3 md:col-span-6 " },
                React.createElement(AccountMenu, null),
                React.createElement("div", { className: "flex flex-row justify-center items-center gap-4 pt-3" },
                    React.createElement(ButtonControl, { label: "Orders", backgroundColor: "bg-primary", size: "xsmall", startIcon: faChartBar, onClick: () => {
                            dispatch(setDrawerOpen(false));
                            navigate("/orders");
                        } }),
                    React.createElement(ButtonControl, { label: "Log Out", backgroundColor: "bg-primary", size: "xsmall", startIcon: faSignOut, onClick: () => {
                            dispatch(sign_out_thunk());
                        } }))),
            React.createElement("div", { className: "col-span-12 lg:col-span-9 md:col-span-6" },
                React.createElement(ProfileDetailsWidget, null)))));
};
